import { useState } from 'react';

import s from '@/components/landing/Landing.module.scss';

const VideoModal = ({ videoURL, closePopup }: { videoURL: string; closePopup: () => void }) => {
  return (
    <div className={'fixed left-0 top-0 z-[150] flex h-full w-full items-center justify-center bg-[rgba(0,0,0,0.6)] backdrop-blur-xl'}>
      <button
        className={
          'absolute right-[10px] top-[14px] inline-flex h-[2.875em] w-[2.875em] items-center justify-center rounded-full bg-[rgba(0,0,0,0.7)] transition-all hover:bg-[rgba(0,0,0,0.9)]'
        }
        onClick={closePopup}
      >
        <svg className="text-white" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 6L18 18" stroke="white" strokeWidth="1.75" strokeLinecap="round" />
          <path d="M18 6L6 18" stroke="white" strokeWidth="1.75" strokeLinecap="round" />
        </svg>
      </button>
      <iframe
        className={s.youtube_item}
        src={`${videoURL}?enablejsapi=1&version=3&playerapiid=ytplayer`}
        title={'YouTube video player'}
        allow={'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'}
        allowFullScreen
      />
    </div>
  );
};

export default VideoModal;

export const useVideoModal = (initialVideoLink = '') => {
  const [videoURL, setVideoURL] = useState(initialVideoLink);

  const openVideoPopup = (videoLink: string) => {
    const scrollEl = document.querySelector('html') as HTMLElement;
    scrollEl.style.overflowY = 'hidden';
    setVideoURL(videoLink);
  };

  const closeVideoPopup = () => {
    const scrollEl = document.querySelector('html') as HTMLElement;
    scrollEl.style.overflowY = 'auto';
    setVideoURL('');
  };

  return {
    videoURL,
    openVideoPopup,
    closeVideoPopup
  };
};
